import React from "react";
import logoTop from '../../assets/img/logo/loading-up.png';
import logoDown from '../../assets/img/logo/loading-down.png';

import './loading.css';

const LoadingScreen = () => {
    return (
      <div className="loading-container">
        {/* Top Half of the Logo */}
        <div className="logo-part top-half">
          <img src={logoTop} alt="Logo Top Half" className="logo-image top" />
        </div>
  
        {/* Bottom Half of the Logo */}
        <div className="logo-part bottom-half">
          <img src={logoDown} alt="Logo Bottom Half" className="logo-image bottom" />
        </div>
      </div>
    );
};
  
export default LoadingScreen;
